.content {
	display: flex;
	align-items: center;
	gap: 4px;
	min-width: 0;
}

.label {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.sortable {
	cursor: pointer;
	user-select: none;
}

.sortIndicator {
	flex-shrink: 0;
	font-size: 14px;
}

.sortIndicator [data-arrow] {
	opacity: 0.35;
	transition: opacity 0.15s ease-in-out;
}

.sortIndicator[data-sort-direction="ascending"] [data-arrow="ascending"],
.sortIndicator[data-sort-direction="descending"] [data-arrow="descending"] {
	opacity: 1;
}
